import React from 'react';
import { Hero } from './components/Hero';
import { Intro } from './components/Intro';
import { SecretsList } from './components/SecretsList';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="bg-gray-50 w-full min-h-screen font-sans" data-id="element-0">
      <main className="max-w-4xl mx-auto pb-24" data-id="element-1">
        <Hero data-id="element-2" />
        <Intro data-id="element-3" />
        <SecretsList data-id="element-4" />
        <Testimonials data-id="element-5" />
        <Guarantee data-id="element-6" />
      </main>
      <StickyCTA data-id="element-7" />
    </div>;
}